export default __webpack_public_path__ + "static/media/background.5c116561.jpg";